import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Card, CardContent, Typography, TextField, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Table, TableHead, TableBody, TableRow, TableCell, Toolbar, Tooltip, Checkbox, CircularProgress, FormControl, Select, MenuItem, InputLabel, ListItemText } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';

const styles = theme => ({
  card: {
    minWidth: 280,
    maxWidth: 1000,
    margin: 'auto',
    marginTop: 100,
    padding: 20,
    textAlign: 'center'
  },
  textField: {
    width: '100%',
    marginTop: 20,
    textAlign: 'left'
  },
  messageContainer: {
    paddingLeft: 20,
    paddingBottom: 20, // Add padding to the bottom
  },
  tableContainer: {
    marginLeft: 20,
    marginTop: 20, // Add top margin to separate it from the message container
  },
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flex: '1 1 100%',
  },
  title: {
    flex: '0 0 auto',
  },
  table: {
    minWidth: 800,
  },
  updateDialog: {
    alignItems: 'center'
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  groupControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  selectControl: {
    marginLeft: 8,
  },
  button: {
    margin: 0,
    padding: 0,
    fontSize: 14,
    width: 40,
  },
  menuItem: {
    float: 'left',
    display: 'block'
  },
  smallSelect: {
    alignItems: 'left',
    minWidth: 34,
    padding: '8px 16px 8px 8px'
  },
  tableCellName: {
    backgroundColor: 'transparent',
  },
  levelCell: {
    width: '80px', // Adjust the width to fit the header title
    padding: 0,
  },
  noBorder: {
    border: 'none',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

class SMSMessage extends Component {
  state = {
    message: '',
    dialogOpen: false,
    isOpen: false,
    isUpdating: false,
    filters: {
      status: 'active',
      level: [],
    },
    notifications: {}, // To store notification states
    selectAll: true, // State for select all checkbox
  };

  componentDidMount() {
    const { getUmpiresList, fetchingUmpiresList, userSeason } = this.props;
    if (fetchingUmpiresList !== 'Loading' || fetchingUmpiresList !== 'Loaded') {
      getUmpiresList(userSeason);
    }
  }

  componentDidUpdate(prevProps){
    const { userSeason, getUmpiresList, umpires } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getUmpiresList(userSeason);
    }
    if (umpires !== prevProps.umpires) {
      getUmpiresList(userSeason);
      this.setState({ isUpdating: false });
    }
  }

  handleInputChange = (event) => {
    this.setState({ message: event.target.value });
  };

  handleSendMessage = () => {
    this.setState({ dialogOpen: true });
  };

  handleCloseDialog = () => {
    this.setState({ dialogOpen: false });
  };

  handleConfirmSend = () => {
    const { message, filters, notifications } = this.state;
    const { umpiresSeason, umpiresSeasonList, userSeason } = this.props;

    // Filter the umpires based on the current filters and notify setting
    const recipients = umpiresSeasonList
      .filter(umpireId => {
        const umpire = umpiresSeason[umpireId];

        if (!umpire) {
          return false; // Skip if umpire is undefined
        }

        const umpireLevel = umpiresSeason[umpireId][userSeason] ? umpiresSeason[umpireId][userSeason].umpireLevel : 0;
        const isActive = umpire.isActive;
        //Notify value by default doesn't exist but should default to true
        const notify = notifications[umpireId] ? notifications[umpireId].notify : true;

        const levelMatches = filters.level.length === 0 || filters.level.includes(umpireLevel);
        const statusMatches = filters.status === 'all' || 
                              (filters.status === 'active' && isActive) || 
                              (filters.status === 'inactive' && !isActive);
        const notifyMatches = notify;

        if (levelMatches && statusMatches && notifyMatches) {
          console.log("Umpire:", umpire);
        }
        return levelMatches && statusMatches && notifyMatches;
      })
      .map(umpireId => umpiresSeason[umpireId].phoneNumber);

    console.log("Message sent:", message);
    console.log("Recipients:", recipients);

    // Send the message to the filtered recipients
    this.props.sendMessage(message, recipients);

    this.setState({ message: "" });
    // Close the dialog
    this.setState({ dialogOpen: false });
  };



  handleCheckboxChange = event => {
    const { id, checked } = event.target;
    const [memberId, column] = id.split('-');

    if (column === 'notify') {
      this.setState(prevState => ({
        notifications: {
          ...prevState.notifications,
          [memberId]: {
            ...prevState.notifications[memberId],
            notify: checked,
          },
        },
      }), () => {
        console.log(`Updated notification for member ${memberId}:`, this.state.notifications[memberId]);
      });
    }
  };

  handleSelectAll = event => {
    const { checked } = event.target;
    const { umpiresSeasonList } = this.props;

    let updatedNotifications = {};
    umpiresSeasonList.forEach(umpId => {
      updatedNotifications[umpId] = {
        notify: checked,
      };
    });

    this.setState({
      notifications: updatedNotifications,
      selectAll: checked,
    }, () => {
      console.log(`Select all notifications: ${checked}`);
    });
  };

  handleFilterDialog = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleFilterChange = event => {
    this.setState({
      filters: { ...this.state.filters, [event.target.name]: event.target.value }
    });
  };

  render() {
    const { umpiresSeason, umpiresSeasonList, userSeason, classes } = this.props;
    const { message, dialogOpen, filters, selectAll } = this.state;
    let renderUmp = false;

    return (
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            SMS Message
          </Typography>
          <div className={classes.messageContainer}>
            <TextField
              id="message-input"
              label="Type your message here"
              multiline
              rows={4}
              variant="outlined"
              className={classes.textField}
              value={message}
              onChange={this.handleInputChange}
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.handleSendMessage}
            >
              Send
            </Button>
          </div>
          <div className={classes.tableContainer}>
            <Paper className={classes.root}>
              <Toolbar className={classes.toolbar}>
                <div className={classes.title}>
                  <Typography variant="h5">
                    Umpire Notification Table
                  </Typography>
                </div>
                <div className={classes.spacer} />
                <div>
                  <Tooltip id="tooltip-umpfilter" disableFocusListener={true} title="Filter Umpires">
                    <Button
                      className={classes.button}
                      variant="contained" size="small" color="primary"
                      onClick={this.handleFilterDialog}
                    >
                      <FilterList />
                    </Button>
                  </Tooltip>
                </div>
              </Toolbar>
              <Dialog className={classes.updateDialog} open={this.state.isUpdating}>
                <div>
                  <CircularProgress className={classes.progress} />
                </div>
              </Dialog>
              <Dialog
                open={this.state.isOpen}
                onClose={this.handleClose}
              >
                <DialogTitle>Filter Umpires</DialogTitle>
                <DialogContent>
                  <div className={classes.selectControl}>
                    <InputLabel id="level-multiple-checkbox-label">Umpire Level</InputLabel>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="level-multiple-checkbox-label"
                        id="level-multiple-checkbox"
                        multiple
                        value={this.state.filters.level}
                        onChange={this.handleFilterChange}
                        renderValue={(selected) => selected.join(', ')}
                        name="level"
                      >
                        {[1, 2, 3, 4, 5, 6, 7].map((level) => (
                          <MenuItem key={level} value={level}>
                            <Checkbox checked={this.state.filters.level.indexOf(level) > -1} />
                            <ListItemText primary={level} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.groupControl}>
                    <Typography variant="body1">Status</Typography>
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="status"
                          value="all"
                          checked={this.state.filters.status === "all"}
                          onChange={this.handleFilterChange}
                        />
                        All
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="status"
                          value="active"
                          checked={this.state.filters.status === "active"}
                          onChange={this.handleFilterChange}
                        />
                        Active
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="status"
                          value="inactive"
                          checked={this.state.filters.status === "inactive"}
                          onChange={this.handleFilterChange}
                        />
                        Inactive
                      </label>
                    </div>
                  </div>
                </DialogContent>
                <DialogActions>
                  <Button className={classes.button}
                    variant="contained" size="small" color="primary"
                    onClick={this.handleClose}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
              <Table className={classes.table} padding="dense">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCell}>
                      <Typography variant="body1">Notify</Typography>
                      <Checkbox
                        checked={selectAll}
                        onChange={this.handleSelectAll}
                      />
                    </TableCell>
                    <TableCell className={classes.tableCell}><Typography variant="body1">Name</Typography></TableCell>
                    <TableCell><Typography variant="body1">Phone Number</Typography></TableCell>
                    <TableCell className={classes.levelCell} align="center"><Typography variant="body1">Level</Typography></TableCell>
                    <TableCell align="center"><Typography variant="body1">Active</Typography></TableCell>
                    <TableCell align="center"><Typography variant="body1">Youth</Typography></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {umpiresSeasonList.map((umpId, index) => {
                    renderUmp = false;
                    const isActive = umpiresSeason[umpId] ? umpiresSeason[umpId].isActive : false;
                    const umpireLevel = umpiresSeason[umpId][userSeason] ? umpiresSeason[umpId][userSeason].umpireLevel : 0;
                    const notify = this.state.notifications[umpId] ? this.state.notifications[umpId].notify : true;
                    const isYouth = umpiresSeason[umpId] ? umpiresSeason[umpId].isYouth  : false;

                    if (((filters.level.length === 0) || (filters.level.includes(umpireLevel))) &&
                      ((filters.status === 'all') || ((filters.status === 'active') && isActive) || ((filters.status === 'inactive') && !isActive))) {
                      renderUmp = true;
                    }

                    if (renderUmp) {
                      return (
                        <TableRow key={umpiresSeason[umpId].memberId} hover>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={notify}
                              onChange={this.handleCheckboxChange}
                              id={`${umpiresSeason[umpId].memberId}-notify`}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.tableCellName}>
                            <Typography variant="body1">
                              {umpiresSeason[umpId].firstName + ' ' + umpiresSeason[umpId].lastName}
                            </Typography>
                          </TableCell>
                          <TableCell><Typography variant="body1">{umpiresSeason[umpId].phoneNumber}</Typography></TableCell>
                          <TableCell className={classes.levelCell} align="center">
                            <Typography variant="body1" className={classes.smallSelect}>
                              {umpireLevel}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={isActive}
                              disabled  // Make it read-only
                              color="primary"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={isYouth}
                              disabled  // Make it read-only
                              color="primary"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }
                    return null;
                  })}
                </TableBody>
              </Table>
            </Paper>
          </div>
        </CardContent>
        <Dialog
          open={dialogOpen}
          onClose={this.handleCloseDialog}
        >
          <DialogTitle>Confirm Send</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to send this message?
            </DialogContentText>
            <DialogContentText>
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleConfirmSend} color="primary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
    );
  }
}

SMSMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  sendMessage: PropTypes.func.isRequired, // Assuming sendMessage is passed as a prop
  getUmpiresList: PropTypes.func.isRequired,
  updateUmp: PropTypes.func.isRequired,
  fetchingUmpiresList: PropTypes.string.isRequired,
  userSeason: PropTypes.string.isRequired,
  umpiresSeason: PropTypes.object.isRequired,
  umpiresSeasonList: PropTypes.array.isRequired
};

export default withStyles(styles, { withTheme: true })(SMSMessage);



// WEBPACK FOOTER //
// ./src/components/SMSMessage.js